import { Storybook } from "@tento-ui/ui/storybook";
import { PomodoroNotch } from "./notch";
import { Button } from "@tento-ui/components/button/button";

export class PomodoroNotchStoryBook extends Storybook.Default {
  title(): string {
    return "Pomodoro Notch";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "fixed",
        render: () => {
          const $n = PomodoroNotch.make();
          $n.toggleAttribute("fixed");
          document.body.appendChild($n);

          let revealed = false;
          return Button.makeWith("Toggle Notch", {
            onClick: () => {
              revealed = !revealed;
              $n.toggleAttribute("revealed", revealed);
            },
          });
        },
      },
      {
        title: "Running",
        render: () => {
          const $c = PomodoroNotch.make().assignStyles({
            position: "relative",
            top: "0",
            // width: "100%",
            // maxWidth: "400px",
          });
          $c.toggleAttribute("visible", true);
          $c.bind({
            time: "25:00",
            label: "Focus",
            color: "var(--red)",
            state: "running",
          });
          return $c;
        },
      },
      {
        title: "Paused",
        render: () => {
          const $c = PomodoroNotch.make().assignStyles({
            position: "relative",
            top: "0",
            // width: "100%",
            // maxWidth: "400px",
          });
          $c.toggleAttribute("visible", true);
          $c.bind({
            time: "12:34",
            label: "Short Break",
            color: "var(--green)",
            state: "paused",
          });
          return $c;
        },
      },
    ];
  }
}
